import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IFormPermToAssessRemind } from "../Models/Forms/IFormPermToAssessRemind";

@Injectable()
export class FormPermToAssessRemindService extends BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormPermToAssessRemind(id: number) {
    return this._http.get(this._baseUrl + "api/FormPermToAssessRemind/" + id)
      .map((response: IFormPermToAssessRemind) => response as IFormPermToAssessRemind)
      .catch(this.errorHandler);
  }

  insertUpdateFormPermToAssessRemind(formPermToAssessRemindDetails: IFormPermToAssessRemind) {
    return this._http.post(this._baseUrl + 'api/FormPermToAssessRemind', formPermToAssessRemindDetails)
      .map((response: IFormPermToAssessRemind) => response as IFormPermToAssessRemind)
      .catch(this.errorHandler);
  }

  validateForm(id: number) {
    return this._http.get(this._baseUrl + "api/FormPermToAssessRemind/ValidateForm" + id)
      .map((response: string[]) => response as string[])
      .catch(this.errorHandler)
  }

  deletePermToAssessRemind(id) {
    return this._http.delete(this._baseUrl + "api/FormPermToAssessRemind" + id)
      .map((response: IFormPermToAssessRemind) => response as IFormPermToAssessRemind)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }

}


